module.exports = __webpack_public_path__ + "static/media/main.a4f2bfdf.png";